export default __webpack_public_path__ + "static/media/Identify-Maturity-Assessment.ef051b6f.svg";